import { Currency } from 'ha/constants/Currencies';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from '../constants';
import { PaymentMethod, PaymentMethodDetail, PaymentMethodType } from './types';

export type Payload = {
  methodType: PaymentMethodType;
  methodDetail?: PaymentMethodDetail;
  currency?: Currency;
  token1?: string;
};

export type Response = {
  method: PaymentMethod;
  creationData: {
    redirectUrl?: string;
    accessKey: string;
    cardData: string;
  };
};

export default (makeCall: MakeCall) => (data: Payload) =>
  makeCall<Response>('POST', `${APIV2_URL}/payment/method`, { data });
